var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalgar4Ny01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 122.6 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "0 70.85 130.53 70.85 130.53 2.42 0 2.42 0 70.85"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.25,
    y1: 38,
    x2: 108.72,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.79,
    y1: 16.28,
    x2: 17.79,
    y2: 59.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.98,
    y1: 16.37,
    x2: 26.76,
    y2: 59.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30.06,
    y1: 16.37,
    x2: 33.87,
    y2: 59.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.95,
    y1: 16.37,
    x2: 37.14,
    y2: 59.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.22,
    y1: 16.28,
    x2: 53.22,
    y2: 59.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 58.41,
    y1: 16.37,
    x2: 62.19,
    y2: 59.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 69.27,
    y1: 16.37,
    x2: 65.49,
    y2: 59.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 74.49,
    y1: 16.28,
    x2: 74.49,
    y2: 59.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.68,
    y1: 16.37,
    x2: 83.46,
    y2: 59.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 97.62,
    y1: 16.37,
    x2: 93.84,
    y2: 59.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 102.81,
    y1: 16.28,
    x2: 102.81,
    y2: 59.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalgar4Ny01);
export default __webpack_public_path__ + "static/media/galgar 4 ny-01.03f52792824bdaa715818ba6da3e3428.svg";
export { ForwardRef as ReactComponent };